<section class="page">
  <article *ngIf="page === 'home'" class="featured-property-title">
    <h2 id="title" translate>components.homePage.featuredProperties</h2>
    <p id="text" translate>
      components.homePage.carefullySelectedProperties
    </p>
  </article>
  <article class="cards-container cards-grid">
    <div class="card" *ngFor="let property of properties; index as i">
      <app-cards-home
        [cardData]="property"
        (onNavigationOverview)="onRefreshPage($event)"
        [index]="i"
      ></app-cards-home>
    </div>
  </article>
</section>
